import { useNavigate } from 'react-router-dom'
import '../onboarding/onboarding.css'
import './settings.css'

const DOCS = [
  { id: 'terms-and-conditions', label: 'Terms and conditions' },
  { id: 'privacy-policy', label: 'Privacy policy' },
  { id: 'subscription-payment-terms', label: 'Subscription & payment terms' },
  { id: 'cookie-policy', label: 'Cookie policy' },
  { id: 'community-guidelines', label: 'Community guidelines' },
  { id: 'digital-services-act', label: 'Digital Services Act (DSA) notice & action policy' },
  { id: 'safety-tips', label: 'Safety tips' },
  { id: 'handling-complaints-dispute', label: 'Handling of complaints & online dispute resolution' }
]

const SettingsLegal = () => {
  const navigate = useNavigate()
  const onBack = () => navigate('/app/profile/settings')
  const onDoc = (id) => {
    if (id === 'terms-and-conditions') {
      navigate(`/legal/${id}`)
    } else {
      navigate(`/app/profile/settings/legal/${id}`)
    }
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← Back</button>
        </div>
        <h1 className="h1">Legal documents and Information</h1>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {DOCS.map((doc) => (
            <li key={doc.id}>
              <button type="button" className="settings-list-item" onClick={() => onDoc(doc.id)}>
                {doc.label}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SettingsLegal
